import { en, type ChromeMessages } from "./chrome_en.ts";

/** Swedish web app chrome. Unlisted keys stay English (product names and tokens). */
export const sv: ChromeMessages = {
  ...en,
  menuAttachOriginalTarget: "Bifoga ursprungligt mål",
  menuAttachOriginalTargetTitle: "Skicka även den råa målfilen (OPT / schema). Av: bara det kompakta slot-trädet, mycket mindre.",
  menuAiLanguages: "Språk…",
  aiLanguagesTitle: "Språk",
  aiLanguagesIntro: "Källans språk avgör vilket målspråk AI:n och panelerna använder först.",
  aiSourceLanguagesLabel: "Källspråk (prioritetsordning)",
  aiSourceLanguagesDetected: "Tomt = upptäcks från källan: {langs}",
  aiSourceLanguagesNone: "Tomt = upptäcks från källan (inget upptäckt än)",
  aiSourceLanguagesInvalid: "Okänd språkkod: {codes}",
  aiContextLanguagesLabel: "Måletiketter som skickas till AI:n",
  aiContextMatched: "Första målspråket + de som källan använder",
  aiContextLang1: "Bara första målspråket (minst tokens)",
  aiContextAll: "Alla målspråk",
  aiLanguagesPreview: "Målspråk: {order}. Skickas till AI:n: {ai}.",
  langWidgetTargetAria: "Språk för målets etiketter",
  langWidgetSourceAria: "Språk för källans beskrivningar",
  langWidgetTitle: "Visas på",
  langWidgetFollow: "Följ källan",
  langWidgetChosen: "ditt val",
  langWidgetUnknown: "Inte en språkkod enligt ISO 639-1: {code}",
  openInAiChat: "Öppna i AI-chatt",
  aiChat: "AI-chatt",
  addToAiChat: "Lägg till i AI-chatt",
  aiChatStoredPrompts: "Sparade promptar",
  aiChatSend: "Skicka",
  aiChatClear: "Rensa historik",
  appTitle: "intEHRgrator — Integrationsverktyg",
  copyPrompt: "Kopiera prompt",
  copyPromptTitle: "Kopiera AI-prompt med inbäddade filer",
  callAi: "Anropa AI",
  callAiTitle: "Anropa konfigurerad AI med mappningsverktyg (MCP / Agent API-namn)",
  aiMenuAria: "AI-hjälp",
  menuCopyPrompt: "Kopiera prompt",
  menuCallAi: "Anropa AI",
  menuAiCredentials: "Konfigurera AI-uppgifter…",
  menuEmbedFiles: "Bädda in filer i prompten",
  menuAttachFiles: "Bifoga filer i chatten",
  menuBrowseUris: "Bläddra bland URI:er (när det finns)",
  menuAiCopyHeading: "kopiera/klistra in för extern AI-chatt",
  menuAiOwnHeading: "Din egen AI",
  menuAiDesktopHeading: "Skrivbord",
  menuLocalMcp: "Lokal MCP-server…",
  localMcpTitle: "Lokal MCP-server",
  localMcpIntro:
    "Starta eller stoppa servern som din IDE använder för att redigera den här arbetsytan. Kopiera konfigurationen till IDE:ns MCP-inställningar. Låt appen vara öppen.",
  localMcpRunning: "Igång — en IDE kan ansluta",
  localMcpStopped: "Stoppad — IDE:er kan inte ändra arbetsytan",
  localMcpStart: "Starta",
  localMcpStop: "Stoppa",
  localMcpUrlLabel: "Agent-API-adress",
  localMcpTokenLabel: "Token",
  localMcpNoToken: "Ingen token (endast loopback)",
  localMcpConfigLabel: "IDE-konfiguration (mcp.json)",
  localMcpCopy: "Kopiera konfiguration",
  localMcpCopied: "Konfigurationen kopierades",
  localMcpUnavailable: "Skrivbordsservern svarade inte.",
  menuFile: "Arkiv",
  menuAi: "AI",
  importAi: "Importera AI-förslag",
  exampleSets: "Exempeluppsättningar",
  exampleSetsTitle: "Ladda en komplett exempeluppsättning (källa, mål, valfri mappning) från katalog-URI:er",
  exampleSetsMenuAria: "Välj exempeluppsättning",
  functions: "Funktioner",
  functionsTitle: "Spara, ladda eller bidra med Blockly-funktioner; bläddra i GitHub-funktionsbiblioteket",
  newProject: "Nytt projekt",
  loadProject: "Ladda projekt",
  saveAs: "Spara som",
  exportProject: "Exportera projekt",
  importProject: "Importera projekt",
  betterForm: "Öppna Better-formulär",
  betterFormTitle: "Den licensierade Better-renderaren stannar i den här webbläsaren. Ladda upp den i visaren om den saknas.",
  help: "Hjälp",
  helpTitle: "Handledning och ärenderapportering",
  helpMenuAria: "Hjälpmeny",
  userTutorial: "Användarhandledning",
  reportBug: "Rapportera ett fel",
  requestFeature: "Önska en funktion",
  uiLanguageAria: "Gränssnittsspråk",
  showSource: "Källa",
  source: "Källa",
  clickToMapAria: "Klickmappning till Handlebars",
  clickToMapHtml:
    "Klicka på en nod i källschemat eller exempelinstansen för att mappa den till det valda Blockly-blocket. Om ett kodtextblock (LANG = Handlebars) eller ett Handlebars-textblock är valt infogas en VMS-Hbs {{path}} vid markören. Håll Shift för nästlad {{#with}} / {{#each}}. Annars fyller lyssningsläge det väntande källfrågeblocket.",
  slideSourceAway: "Skjut undan Källa",
  handlebarsHint: "Handlebars-infogning redo — klicka en källnod för {{path}}; Skift+klick för nästlad #with/#each.",
  schema: "Schema",
  schemaFormatsAria: "Format som stöds för schema",
  schemaFormatsHtml:
    "Stöds: JSON Schema, JSON- eller XML-dokument, XSD-exempel samt openEHR Web Template, Composition JSON eller en GitHub-.t.json (arketyper hämtas från samma repo).<br>Ladda från lokal fil, en URL eller ▾ → Från GitHub-mall….",
  loadSchema: "Ladda schema",
  schemaMenuAria: "Fler sätt att ladda schema",
  examples: "Exempel",
  exampleFormatsAria: "Format som stöds för exempel",
  exampleFormatsHtml:
    "Stöds: JSON- eller XML-instansfiler.<br>Ladda en fil, en lokal mapp, en GitHub-mapp (▾) eller en enstaka fil från URL.",
  addExample: "+ Lägg till exempel",
  exampleMenuAria: "Fler sätt att ladda exempel",
  mappingEditors: "Mappningsredigerare",
  undo: "Ångra",
  redo: "Gör om",
  expandAll: "Expandera alla",
  expandAllTitle: "Expandera alla nästlade block",
  collapseAll: "Fäll ihop alla",
  collapseAllTitle: "Fäll ihop alla nästlade block",
  expandChildren: "Expandera barn",
  collapseChildren: "Fäll ihop barn",
  useCodedText: "Använd kodad text (DV_CODED_TEXT)",
  usePlainText: "Använd vanlig text (DV_TEXT)",
  followAgent: "Följ agent",
  leaseTitle: "Reserverad av {agent} till {time}: andra MCP-agenter kan inte ändra {what}. Du får en fråga först.",
  leaseWhatSlot: "den här platsen",
  leaseWhatSubtree: "något i det här delträdet",
  leaseSubtree: "delträd",
  leasesChip: "Reservationer",
  leasesChipTitle: "MCP-agenternas reservationer just nu (vem arbetar med vad). Klicka för att visa nästa.",
  leaseWarningTitle: "En agent arbetar med det här",
  leaseWarningIntro:
    "{agent} har reserverat det du just ändrade. Din ändring syns men är inte sparad än. Ändra ändå så vinner du: skriver agenten där också används inte dess ändring. Du får inte frågan igen för den här reservationen.",
  leaseWarningEndsIn: "reservationen upphör om {time}",
  leaseWarningEnded: "reservationen har upphört",
  leaseWarningEdit: "Ändra ändå",
  leaseWarningCancel: "Avbryt",
  leaseWarningEdited: "Du ändrade {slots}, som {agent} har reserverat. Skriver {agent} där också står din ändring kvar.",
  leaseWarningCancelled: "Din ändring togs tillbaka: {agent} har reserverat {slots}.",
  leaseWarningExpired: "{agent}s reservation upphörde; din ändring av {slots} är sparad.",
  leaseHumanWins: "{agent}s ändring av {slots} användes inte: du ändrade den under {agent}s reservation (du vinner).",
  followAgentTitle: "När ikryssad panoreras huvudytan till block som en agent just ändrade",
  openViewer: "Öppna visningsfönster",
  openViewerTitle: "Öppna visningsfönster: live-yta, agentförklaring och tidslinje med historik",
  downloadJson: "Ladda ner JSON",
  downloadWorkspaceTitle: "Ladda ner hela Blockly-arbetsytan som JSON (inklusive koordinater och layout)",
  mappingViewsAria: "Textvyer i mappningsredigeraren",
  mappingSpec: "Mappningsspec",
  specLayoutAria: "Vyalternativ för mappningsspec",
  listView: "Listvy (alla rötter)",
  tabbedView: "Flikvy (per rot)",
  download: "Ladda ner",
  downloadSpecTitle: "Ladda ner hela Blockly-arbetsytan som JSON",
  downloadSpecAria: "Ladda ner hela Blockly-arbetsytan som JSON",
  upload: "Ladda upp",
  uploadSpecTitle: "Ladda upp en Blockly-arbetsyta som JSON",
  uploadSpecAria: "Ladda upp en Blockly-arbetsyta som JSON",
  specEditorActionsAria: "Åtgärder för mappningsspec-redigeraren",
  searchSpecTitle: "Sök i mappningsspec",
  searchSpecAria: "Sök i mappningsspec",
  copySpecTitle: "Kopiera mappningsspec",
  copySpecAria: "Kopiera mappningsspec",
  scriptEditorActionsAria: "Åtgärder för konverteringsskript-redigeraren",
  searchScriptTitle: "Sök i konverteringsskript",
  searchScriptAria: "Sök i konverteringsskript",
  copyScriptTitle: "Kopiera konverteringsskript",
  copyScriptAria: "Kopiera konverteringsskript",
  downloadScriptAria: "Ladda ner konverteringsskript",
  testEditorActionsAria: "Åtgärder för testresultat-redigeraren",
  searchTestTitle: "Sök i testresultat",
  searchTestAria: "Sök i testresultat",
  copyTestTitle: "Kopiera testresultat",
  copyTestAria: "Kopiera testresultat",
  downloadTestAria: "Ladda ner resultatet från konverteringstestet",
  markWarned: "Markera varnade valfria",
  markWarnedTitle: "Markera omappade valfria scaffold-träd som visar en villkorsvarning",
  deleteMarked: "Ta bort markerade",
  deleteMarkedTitle: "Ta bort ikryssade noder och deras barn från arbetsytan",
  undoHistoryHint: "Tips: Öppna arbetsytan (observatör) för hela agenttidslinjen och tillskriven historik.",
  undoLastEdit: "Ångra senaste ändringen på arbetsytan.",
  redoLastEdit: "Gör om ändringen på arbetsytan.",
  railTarget: "Målschema",
  railTargetTitle: "Målschema",
  railScripts: "Skript",
  railScriptsTitle: "Genererade konverteringsskript",
  railTest: "Test",
  railTestTitle: "Konverteringstest",
  targetPreviews: "Mål och förhandsvisning",
  targetFormatsAria: "Format som stöds för mål",
  targetFormatsHtml:
    "Stöds: openEHR OPT/OPT2, Web Template, JSON Schema, XML Schema (XSD), ADL, fri mall eller en GitHub-.t.json (arketyper hämtas från samma repo).<br>Välj mål och standardkontextkarta tillsammans. ▾ ger också fil, URL, GitHub och oförstörande uppdatering.",
  loadTarget: "Ladda mål och standardkontextkarta",
  loadTargetTitle: "Ladda ett mål och välj en standardkontextkarta",
  targetMenuAria: "Fler sätt att ladda mål",
  modelLanguageAria: "Ontologispråk för målmodellen",
  scriptFormatsAria: "Format för konverteringsskript",
  scriptFormatsHtml:
    "Mappningsförhandsvisning tolkar mappningen utan att skapa ett skript. Konverteringsskript (hittills): TypeScript, Java, Handlebars, XQuery och Go Template. TypeScript, Handlebars, Go Template och XQuery körs också i konverteringstestet. Java skapar en Archie-klass men körs inte i webbskalet. För openEHR-mål styr JSON- eller XML-instans hur XQuery serialiserar kompositionen.<br>Ladda ner i skripteditorn sparar det genererade skriptet. Ladda ner ovanpå konverteringstestet sparar den instansen.",
  mappingPreview: "Mappningsförhandsvisning",
  instance: "Instans",
  instanceTitle: "Önskad openEHR-instansform. XQuery-export och testkörning använder den serialiseringen.",
  jsonInstance: "JSON-instans",
  xmlInstance: "XML-instans",
  slideTargetAway: "Skjut undan Mål och förhandsvisning",
  tabTargetSchema: "Målschema",
  tabScripts: "Genererade konverteringsskript",
  tabTest: "Konverteringstest",
  generatedScripts: "Genererade konverteringsskript",
  downloadScriptTitle: "Ladda ner konverteringsskript",
  testRuns: "Konverteringstest",
  validateAs: "Validera som",
  validateTitle: "ehrtslib-förval för JSON-avserialisering vid mallvalidering",
  hybrid: "Hybrid (tillåtande)",
  defaultMode: "Standard",
  compact: "Kompakt",
  canonicalStrict: "Kanonisk strikt",
  terse: "Kort",
  runTest: "Kör test",
  autoplay: "▶ Autospel",
  pause: "⏸ Pausa",
  downloadTestTitle: "Ladda ner resultatet från konverteringstestet",
  ready: "Redo",
  loadSchemaEmpty: "Ladda en schemafil.",
  selectExampleTab: "Välj en exempelflik.",
  addExamplesEmpty: 'Lägg till exempelinstanser för att aktivera "Konverteringstest" under Mål och förhandsvisning',
  loadTargetEmpty: "Ladda ett målschema eller en mall.",
  statusNoTarget: "Inget mål",
  statusTarget: "Mål: {id}",
  statusScript: "Skript: {name}",
  statusNoExample: "Inget exempel",
  statusExample: "Exempel: {name}",
  statusUnmapped: "{n} omappade obligatoriska",
  unsavedChanges: "osparade ändringar",
  autosavedAt: "autosparad {time}",
  functionsIntroHtml:
    "Spara en Blockly-funktion (definition + beslutstabeller) till disk, ladda in en i den här mappningen eller bläddra i GitHub-funktionsbiblioteket. Bidrag skapar ett granskningsärende — det mergas inte automatiskt.",
  onThisCanvas: "På den här arbetsytan",
  loadFromDisk: "Ladda från disk…",
  functionLibrary: "Funktionsbibliotek",
  catalogUrl: "Katalog-URL",
  loadCatalog: "Ladda katalog",
  close: "Stäng",
  nameInUse: "Namnet används redan",
  cancel: "Avbryt",
  replace: "Ersätt",
  rename: "Byt namn",
  contributeTitle: "Bidra med funktion",
  contributeIntroHtml:
    "Öppnar ett GitHub-ärende i <code>regionstockholm/intehrgrator</code> med din beskrivning och funktionsdefinitionen. Förvaltare granskar för hand.",
  functionName: "Funktion:",
  descriptionRequired: "Beskrivning (obligatorisk)",
  contributePlaceholder: "Vad den returnerar, språk, beslutstabell, parametrar…",
  needGithubHtml:
    'Behöver du ett GitHub-konto? <a id="function-contribute-signup" href="https://github.com/signup" target="_blank" rel="noopener noreferrer">Skapa ett konto</a> eller <a id="function-contribute-login" href="https://github.com/login" target="_blank" rel="noopener noreferrer">logga in</a> och skicka sedan in.',
  openGithubIssue: "Öppna GitHub-ärende",
  saveAsIntro: "Spara den aktuella arbetsytan under ett namn du kan ladda senare.",
  projectName: "Projektnamn",
  projectNamePlaceholder: "Mitt integrationsprojekt",
  save: "Spara",
  loadProjectTitle: "Ladda projekt",
  loadProjectIntro: "Välj en sparad arbetsyta. Laddning ersätter det aktuella projektet.",
  loadFromUrl: "Ladda från URL",
  loadUrlHint: "Klistra in en https-URL. GitHub-filsidor omvandlas till råinnehåll.",
  recentUrls: "Senaste URL:er",
  load: "Ladda",
  jointTitle: "Ladda mål och standardkontextkarta",
  jointIntroHtml:
    "Välj mål och standardkontextkarta tillsammans. Bekräfta bygger <strong>mallskelettet</strong> och <strong>standardpunkter</strong>. <strong>Ny</strong> laddar målet bara till fliken Målschema så att du kan dra brickor och värden och sedan tillämpa på arbetsytan.",
  targetLegend: "Mål",
  noTargetYet: "Inget mål valt ännu.",
  fromFile: "Från fil…",
  useLoadedTarget: "Använd laddat mål",
  targetUrl: "Mål-URL",
  fetchUrl: "Hämta URL",
  mapLegend: "Standardkontextkarta",
  factoryMapHtml: "openEHR-fabrik (<code>defaults_openEHR_1</code>)",
  keepMap: "Behåll kartan som redan finns på arbetsytan",
  newMap: "Ny (tom) — målschema först, sedan Tillämpa",
  browsedFile: "Bläddrad fil",
  browseMap: "Bläddra efter kartfil…",
  loadAndScaffold: "Ladda och bygg skelett",
  loadIntoSchema: "Ladda till målschema",
  refreshReport: "Uppdateringsrapport",
  copyMergePrompt: "Kopiera sammanslagningsprompt",
  aiCredentialsTitle: "AI-uppgifter",
  aiCredentialsIntroHtml:
    'Valfri OpenAI-kompatibel chattändpunkt så att <strong>Anropa AI</strong> kan mappa från webbskalet. Uppgifterna stannar i den här webbläsaren — inte i projektpaketet. <strong>Anropa AI</strong> kan använda samma mappningsverktyg som MCP / HTTP Agent API (<code>map_slot</code>, <code>import_suggestions</code>, <code>run_test</code>, …). En AI-stödd IDE med lokal MCP är fortfarande en giltig separat väg. Stegvisa nyckelsidor: <a href="https://github.com/regionstockholm/intehrgrator/blob/main/docs/AI_CREDENTIALS.md" target="_blank" rel="noopener noreferrer" id="ai-credentials-guide">Uppgifter för Anropa AI</a>.',
  provider: "Leverantör",
  customEndpoint: "Egen OpenAI-kompatibel ändpunkt",
  getApiKey: "Hämta en API-nyckel",
  providerDocs: "Leverantörens dokumentation",
  endpoint: "Ändpunkt",
  apiKey: "API-nyckel",
  model: "Modell",
  clear: "Rensa",
  defaultsTitle: "Standardkontextkarta",
  defaultsIntro: "Ladda en sparad karta, bläddra efter fil eller URL, ladda ner den unika standardkontextkartan eller spara arbetsytans karta under ett namn.",
  browseFile: "Bläddra efter fil…",
  loadUrlBtn: "Ladda URL",
  downloadFile: "Ladda ner fil…",
  saveAsEllipsis: "Spara som…",
  saveDefaultsTitle: "Spara standardkontextkarta som",
  saveDefaultsIntro: "Spara den aktuella standardkontextkartan under ett namn du kan välja senare.",
  nameLabel: "Namn",
  hardcodeTitle: "Hårdkoda post i standardkontextkartan",
  hardcodeIntroHtml:
    "Välj en kartnyckel att <strong>bädda in</strong> på arbetsytan. Varje <code>get defaults key …</code>-uppslag för den nyckeln ersätts med en kopia av värdet från den här standardkontextkartan. Därefter läser de platserna inte längre argumentet <code>defaults</code> vid konvertering — de använder det inbäddade blocket. Själva kartan lämnas oförändrad så att du kan hårdkoda andra nycklar senare.",
  importAiTitle: "Importera AI-förslag",
  importAiIntroHtml:
    "Klistra in JSON från AI-chatten (ett råobjekt eller ett <code>intehrgrator-suggestions</code>-staket). Importen valideras mot förslagens JSON Schema; fel syns här och kan kopieras tillbaka till AI:n.",
  suggestions: "Förslag",
  pasteClipboard: "Klistra in urklipp",
  copyErrorsForAi: "Kopiera fel till AI",
  copied: "Kopierat",
  importAction: "Importera",
  notRecommended: "Inte den rekommenderade versionen",
  bleedingEdgeHtml:
    'Vill du experimentera? Den allra senaste bygget (uppdateras vid varje ändring av <code>main</code>) finns alltid på <a id="recommended-version-bleeding-edge-link" href="#">webbplatsens rot</a>.',
  newHereHtml:
    'Ny här? Läs <a id="recommended-version-tutorial-link" href="#">handledningen</a> eller <a id="recommended-version-readme-link" href="#">README</a>.',
  dontShowAgain: "Visa inte det här igen för den här versionen",
  dismiss: "Stäng",
  defaultsBlockAria: "Om standardkontextkartan",
  defaultsBlockHtml:
    "<strong>Standardkontextkartan</strong> är den unika tabellen du skriver här på arbetsytan. Vid <em>konvertering</em> får genererade konverteringsskript den som argumentet <code>defaults</code>, nycklad med <strong>körningsnyckel</strong> (<code>language</code>, <code>facility</code>, …). <code>maps_get(\"defaults\", runtimeKey)</code> slår upp dem. Körtids kod kan slå ihop den påsen med värden per meddelande, andra namngivna kartor och blad — kartan på arbetsytan är den återanvändbara baslinjen, inte literaler i varje plats.<br><strong>Scaffold-mål</strong> (brickor) är bara RM-sökvägar vid författande, inte körningsnycklar: <code>Class.attribute</code> (t.ex. <code>COMPOSITION.composer</code>, <code>EVENT_CONTEXT.health_care_facility</code>), anfadersökvägar och jokertecken (<code>*.language</code> tänder varje språkplats). En mer specifik bricka vinner när flera matchar samma plats. Tomma brickor → en ren körningsnyckel som inte tänder något. Extra nycklar kan fortfarande slås upp i kartan.<br>Bekräfta, <strong>Tillämpa standardkontextkarta</strong> eller en senare måluppdatering kopplar <strong>standardpunkter</strong>. Värdeändringar syns direkt i testkörningen. En plats som redan mappats från källan ersätts inte.<br>Mappen öppnar ladda/spara: välj en karta sparad i den här webbläsaren, bläddra efter JSON, ladda en URL, spara en namngiven kopia eller ladda ner kartan som JSON.",
  decisionBlockAria: "Om beslutstabeller",
  decisionBlockHtml:
    "<strong>Beslutstabell</strong> är ett namngivet regelrutnät under Tabeller och kalkylblad: villkorskolumner (likhet, bryr-mig-inte <code>—</code>) och resultatkolumner (värden eller VMS-Mustache-snuttar). Rutnätet äger kolumnnamn och typer; blockets indatakartnycklar hålls i synk.<br>Koppla en indatakarta till höger (nycklar = villkorsrubriker). Resultatlistan returnerar en typad kolumn (🔤 sträng, 🔢 tal, ✓ boolesk) eller <em>alla resultat</em> som en karta (↦). Byte av typ kan koppla loss blocket; ångra/gör om på arbetsytan återställer det.<br>Träffpolicy (FIRST / UNIQUE / COLLECT) finns under Tabeller och kalkylblad. Platta ut nästlade källor till indatakartan (eller via variabler) före utvärdering.",
  fromUrl: "Från URL…",
  refreshFromFile: "Uppdatera från fil…",
  refreshFromUrl: "Uppdatera från URL…",
  noRecentUrls: "Inga senaste URL:er ännu.",
  removeFromHistory: "Ta bort {url} från historiken",
  enterUrl: "Ange en URL.",
  refreshKindFromUrl: "Uppdatera {kind} från URL",
  refreshUrlHint: "Ladda om filen från en URL utan att radera mappningar på arbetsytan. Varningar listar platser eller sökvägar som kanske inte längre passar.",
  kindSchema: "schema",
  kindExample: "exempel",
  kindTarget: "mål",
  kindSource: "källa",
  fromLocalFolder: "Från lokal mapp…",
  fromGithubFolder: "Från GitHub-mapp…",
  fromGithubTemplate: "Från GitHub-mall…",
  loadSchemaFromUrl: "Ladda schema från URL",
  loadSchemaUrlHint: "JSON, XML, XSD eller en GitHub-.t.json-mall (arketyper hämtas från samma repo). GitHub-filsidor omvandlas till råinnehåll.",
  recentSchemaUrls: "Senaste schema-URL:er",
  githubTemplateTitle: "Ladda openEHR-mall från GitHub",
  githubTemplateHint: "Klistra in en GitHub-blob eller rå-URL till en Better-.t.json (eller .adl / .opt). Beroende arketyper hämtas från samma gren.",
  githubTemplateOpenTitle: "Öppna openEHR-mall från GitHub",
  addExampleFromUrl: "Lägg till exempel från URL",
  addExampleUrlHint: "JSON- eller XML-instans. GitHub-filsidor omvandlas till råinnehåll.",
  recentExampleUrls: "Senaste exempel-URL:er",
  githubFolderTitle: "Lägg till exempel från GitHub-mapp",
  githubFolderHint: "Klistra in en GitHub-träd-URL till en mapp. Alla JSON- och XML-filer under den sökvägen laddas.",
  loadTargetFromUrl: "Ladda mål från URL",
  loadTargetUrlHint: "OPT, Web Template, JSON Schema eller en GitHub-.t.json. GitHub-filsidor omvandlas till råinnehåll.",
  recentTargetUrls: "Senaste mål-URL:er",
  loadingCatalog: "Laddar katalog…",
  exampleSetsHeading: "Exempeluppsättningar",
  noExampleSets: "Inga exempeluppsättningar i katalogen",
  catalog: "Katalog",
  bundledCatalog: "Medföljande dummykatalog",
  ehrtslibCatalog: "ehrtslib-katalog (GitHub)…",
  loadCatalogFromUrl: "Ladda katalog från URL…",
  catalogUrlPrompt: "JSON-URL till exempeluppsättningskatalog",
  confirmLoadExampleSet: "Ladda den här exempeluppsättningen? Den aktuella arbetsytan ersätts. Osparade ändringar kan gå förlorade.",
  confirmNewProject: "Starta ett nytt projekt? Den aktuella arbetsytan rensas. Osparade ändringar kan gå förlorade.",
  confirmNewEmpty: "Starta ett nytt tomt projekt?",
  confirmLoadProject: "Ladda det här projektet? Den aktuella arbetsytan ersätts.",
  noSavedProjects: "Inga sparade projekt ännu. Använd Spara som eller vänta på autosparning.",
  lastAutosave: "Senaste autosparning",
  savedProject: "Sparat projekt",
  defaultsUnavailable: "Katalogen för standardvärden är otillgänglig: {detail}",
  noSavedMaps: "Inga sparade standardkontextkartor ännu. Använd Spara som, Ladda ner, Bläddra efter fil eller en URL.",
  savedMap: "Sparad karta",
  noHardcodeEntries: "Standardkontextkartan har inga poster att hårdkoda ännu.",
  selectedFile: "Vald: {name}",
  usingLoaded: "Använder laddad: {name}",
  fetchedFile: "Hämtad: {name}",
  browsedFileLabel: "Bläddrad fil: {name}",
  pasteTargetUrl: "Klistra in en mål-URL först.",
  popupBlockedSvg: "Popup blockerad — laddade ner SVG i stället.",
  popupBlockedEmpty: "Popup blockerad och arbetsytan är tom.",
  openedObserver: "Öppnade agentobservatör / ögonblicksbild av arbetsytan.",
  betterPopupBlocked: "Kunde inte öppna Better-formulärvisaren. Tillåt popup-fönster för den här webbplatsen.",
  schemaMismatch: "Schemaavvikelse:",
  conversionFailed: "Konverteringen misslyckades:",
  templateValidation: "Mallvalidering:",
  noWorkspace: "Ingen Blockly-arbetsyta",
  noFunctionsOnCanvas: "Inga funktioner på arbetsytan. Bryt ut till funktion eller ladda från biblioteket.",
  contribute: "Bidra",
  loadCatalogBrowse: "Ladda katalogen för att bläddra bland utvalda funktioner.",
  catalogNoFunctions: "Katalogen har inga funktioner.",
  loadingLibrary: "Laddar funktionsbibliotek…",
  fnReturnsValue: "{sig} → värde",
  pasteJsonFirst: "Klistra in AI-JSON (eller ett intehrgrator-suggestions-staket) först",
  clipboardEmpty: "Urklippet är tomt eller kan inte läsas i den här webbläsaren",
  noMatches: "Inga träffar",
  searchPlaceholder: "Sök…",
  filterList: "Filtrera lista",
  historyTimeline: "Historiktidslinje",
  historyIntro: "Dra för att förhandsvisa; rollback klipper senare poster. Patch-ångra ger intehrgrator-suggestions v2 JSON.",
  seqLabel: "Sekv",
  previewAtSeq: "Förhandsvisa vid sekv",
  rollbackHere: "Rulla tillbaka hit (förstörande)",
  copyPatchUndo: "Kopiera prompt för patch-ångra",
  timelineDesktopOnly: "Agent API-tidslinjen finns bara i skrivbordsappen.",
  timelineUnavailable: "Agent API otillgängligt — tidslinjen väntar.",
  noHistoryYet: "Ingen historik ännu.",
  selectHistoryPoint: "Välj en historikpunkt.",
  downloadDiscardedConfirm: "Ladda ner den kastade grenen (.intehrgrator) innan du fortsätter?",
  noBundleExport: "Ingen paketdata att exportera för den kastade grenen.",
  downloadedDiscarded: "Laddade ner den kastade grenen.",
  agentsHeading: "Agenter",
  projectLoaded: "Projekt laddat",
  newProjectStatus: "Nytt projekt",
  projectNotFound: "Projektet hittades inte",
  projectImported: "Projekt importerat",
  restoredMapping: "Återställde föregående mappning",
  blocklyMustBeObject: "Blockly-JSON måste vara ett objekt",
  exampleDropJsonXml: "Exempelsläpp: endast JSON- eller XML-filer",
  listeningSourceQuery: "Lyssnar efter källsökväg → källfråga",
  appliedDefaults: "Tillämpade standardkontextkarta",
  refreshPromptCopied: "Sammanslagningsprompt kopierad",
  callingAi: "Anropar AI…",
  providerRejectedTools: "Leverantören avvisade mappningsverktyg; försöker igen med förslags-JSON…",
  aiCredentialsCleared: "AI-uppgifter rensade",
  aiCredentialsSaved: "AI-uppgifter sparade i den här webbläsaren",
  saveAiOrCopy: "Spara AI-uppgifter för att anropa AI, eller använd Kopiera prompt.",
  loadTargetFirst: "Ladda ett mål till målschemat först, och tillämpa sedan standardkontextkartan.",
  targetNodeMissing: "Den målschemanoden finns inte i det laddade målet.",
  dropLeafHint: "Släpp ett löv på scaffold-brickor, ett delträd på en värdesockel eller på tom arbetsyta.",
  emptyMapReady: "Tom standardkontextkarta redo — dra från målschemat och tillämpa sedan.",
  pickTargetFirst: "Välj en målfil eller URL först.",
  corsCallAiHint: "Webbläsarens CORS blockerar ofta molnleverantörer från GitHub Pages. Använd skrivbordsappen (den vidarebefordrar Anropa AI), slå på CORS på en lokal server (Ollama / LM Studio) eller använd Kopiera prompt.",
  savedAs: 'Sparade som "{name}"',
  loadedSchema: "Laddade schema {name}",
  loadedBlockly: "Laddade Blockly-mappning {name}",
  loadedTargetIntoSchema: "Laddade {format}-mål {id} till målschemat (inget produktskelett ännu)",
  loadedTarget: "Laddade {format}-mål {id}",
  loadedFunctionLibrary: "Laddade funktionsbibliotek ({n})",
  loadedFunction: "Laddade funktion {name}",
  loadedExampleCatalog: "Laddade katalog med exempeluppsättningar ({n} {sets})",
  setSingular: "uppsättning",
  setPlural: "uppsättningar",
  loadedExampleSet: 'Laddade exempeluppsättning "{name}"',
  exampleSetFailed: 'Exempeluppsättning "{name}" misslyckades: {detail}',
  addedExample: "Lade till exempel {name}",
  addedExampleMismatch: "Lade till exempel {name} med {n} schema{mismatch}",
  mismatchSingular: "avvikelse",
  mismatchPlural: "avvikelser",
  addedExamples: "Lade till {n} exempel",
  addedExamplesMismatch: "Lade till {n} exempel med {m} schema{mismatch}",
  aiPromptCopied: "AI-prompt kopierad ({delivery})",
  listeningSlot: "Lyssnar efter källsökväg → {slot}",
  mappedWhat: "Mappade {what}",
  mappedSourceQuery: "Mappade källfråga {xpath}",
  importSummary: "Import: {applied} tillämpade, {loops} loopar, {skipped} överhoppade, {errors} fel{schema}",
  importSchemaNote: ", {n} schema",
  importFailed: "Import misslyckades: {detail}",
  targetLoadFailed: "Målladdning misslyckades: {detail}",
  exampleLoadFailed: "Exempelladdning misslyckades: {detail}",
  exampleFolderFailed: "Mapp med exempel kunde inte laddas: {detail}",
  functionCatalogFailed: "Funktionsbibliotekets katalog misslyckades: {detail}",
  exampleCatalogFailed: "Katalogen med exempeluppsättningar misslyckades: {detail}",
  blocklyParseFailed: "Blockly-JSON kunde inte tolkas: {detail}",
  couldNotLoad: "Kunde inte ladda {name}: {detail}",
  autosaveFailed: "Autosparning misslyckades: {detail}",
  modelLanguageStatus: "Modellspråk: {language}",
  refreshedClean: "Uppdaterade {kind} {name} utan mappningskonflikter.",
  refreshedWithWarnings: "Uppdaterade {kind} {previous} → {next}",
  warningCount: "{n} {warnings}:",
  warningSingular: "varning",
  warningPlural: "varningar",
  loadedGithubTemplate: "Laddade GitHub-mall {id} ({n} filer){extra}",
  loadedGithubSchema: "Laddade GitHub-schema {id} ({n} filer){extra}",
  warningsParen: " ({n} varningar)",
  callAiFailed: "Anropa AI misslyckades: {detail}",
  scaffoldTarget: "Scaffold-mål {path} (klicka brickan för att växla *.)",
  nestedOnMap: "Nästlade {label} på standardkontextkartan",
  addedMapEntry: "Lade till post {key} ({path}) på rad {row}",
  addedFromTarget: "Lade till {label} från målschemat",
  addedSource: "Lade till källa {xpath}",
  taskLoadGithub: "Ladda klinisk modell från GitHub",
  taskLoadAndScaffold: "Ladda och bygg målskelett",
  taskLoadExampleSet: "Ladda exempeluppsättning",
  taskLoadTarget: "Ladda mål",
  taskLoadSchema: "Ladda källschema",
  taskLoadMapping: "Ladda mappning",
  taskLoadSheets: "Ladda blad",
  taskLoadDefaults: "Ladda standardkarta",
  taskParseUrl: "Tolka GitHub-URL",
  taskIndexTree: "Lista filer i arkivet",
  taskFetchFiles: "Hämta filer för den kliniska modellen",
  taskParseModels: "Tolka mallar och arketyper",
  taskResolveOpt: "Lös operationell mall",
  taskScaffold: "Bygg mallskelett",
  taskGenerate: "Generera konverteringsskript",
  taskLoadExampleN: "Ladda exempel {n}",
  appDescription: "intEHRgrator — visuellt integrationsverktyg för att mappa källdata till openEHR",
  loadedColon: "Laddad: {name}",
  savedColon: "Sparad: {name}",
  noMappingConflicts: "Inga mappningskonflikter.",
  refreshReportLine: "{kind} {previous} → {next}",
  refreshWarningCount: "{n} varning(ar):",
  hardcodedLookups: "Hårdkodade “{key}” i {n} {lookups}",
  lookupSingular: "uppslag",
  lookupPlural: "uppslag",
  noDefaultsLookups: "Inga maps_get(\"defaults\", \"{key}\")-uppslag hittades på ytan",
  callAiResult: "Anropa AI: {applied} tillämpade · {errors} fel{extra}",
  functionLibraryCount: "Funktionsbibliotek: {n} {functions}",
  functionSingular: "funktion",
  functionPlural: "funktioner",
  renamedFromParen: " (bytte namn från {name})",
  savedBundle: "Sparade {name}",
  descriptionForFunction: "Beskrivning för funktionen \"{name}\" (valfritt):",
  clashExist: "{bits} finns redan. Byt namn behåller båda (standard). Ersätt skriver över den befintliga definitionen.",
  functionQuoted: "Funktion \"{name}\"",
  decisionQuoted: "Beslutstabell \"{name}\"",
  andWord: "och",
  openedContributionIssue: "Öppnade ett bidragsärende för {name}",
  openedGithubForm: "Öppnade GitHub-formuläret för nytt ärende för {name}",
  entrySummary: "{description} Parametrar: {params}. Beslutstabeller: {tables}.",
  recommendedFrozen: "Du använder intEHRgrator {current}, som inte är den rekommenderade versionen för slutanvändare ({recommended}).",
  recommendedBleeding: "Du använder den senaste versionen (uppdateras vid varje ändring av main), inte den rekommenderade stabila versionen ({recommended}).",
  goToRecommended: "Gå till rekommenderad version ({tag})",
  previewingSeq: "Förhandsvisar sekvens {n}…",
  previewLoadedSeq: "Förhandsvisning laddad för sekvens {n} (skrivskyddad; huvudytan är oförändrad).",
  rollbackAsk: "Återställ till sekvens {seq}?\n\n{n} senare poster tas bort.\n\nLadda ner den kastade grenen (.intehrgrator) innan du fortsätter?",
  confirmRollback: "Bekräfta destruktiv återställning till sekvens {seq}?",
  rolledBackSeq: "Återställde till sekvens {n}. Huvudytan synkas.",
  patchPromptCopied: "Patch-prompt kopierad (intehrgrator-suggestions v2). Tillämpa via import_suggestions.",
  optionalAttributes: "Valfria attribut…",
  openViewerMenu: "Öppna visningsfönster…",
  noAgentsYet: "Inga agenter anslutna ännu.",
  aiChatHistoryTrimmed: "Äldre chattvändor togs bort så att anropet håller sig inom {limit} tokens (API:t skickar om hela chatten i varje steg); det här meddelandet bifogar projektkontexten igen.",
  aiChatHistoryFull: "Inget skickat: chattens historik är cirka {tokens} tokens, över gränsen {limit} för den här modellen, och hela historiken skickas med varje anrop. Hur vill du fortsätta?",
  aiChatHistoryTrimChoice: "Fortsätt med kortad historik",
  aiChatHistoryRecapChoice: "Starta ny chatt med sammanfattning",
  aiChatHistoryCancelChoice: "Avbryt",
  aiChatHistoryRecapStarted: "Ny chatt startad. En sammanfattning av den tidigare chatten (dina meddelanden, svaren och mappningarna) skickas med ditt meddelande, tillsammans med projektkontexten.",
  aiChatHistoryCancelled: "Inte skickat. Ditt meddelande finns kvar i rutan.",
  aiChatStorageTrimmed: "Chatten är större än webbläsaren sparar ({limit} tecken). Sidan behåller hela chatten, men efter omladdning finns bara de senaste vändorna kvar.",
};
